import React from 'react'
import ListLayout from "../common/ListLayout";
import { useState, useEffect } from 'react';
import { useGetAllMedicalInfoQuery,useDeleteMedicalMutation } from '../../../store/api/contact'
import DetailModal from './DetailModal';
import ConfirmDeleteModal from '../common/DeleteModal';
function Contacted() {
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
     const [deleteMed] = useDeleteMedicalMutation();
    const [count, setCount] = useState(0);
    const [filters, setFilters] = useState({});
    const [tableData, setTableData] = useState([]);
    const [medicalId, setMedicalId] = useState(false)
    const [isModalOpen, setIsmodelOpen] = useState(false)
    const { data: contactsData } = useGetAllMedicalInfoQuery({
        page: currentPage,
        page_size: pageSize,
        ...filters,
    });

    const [isDeleting, setIsDeleting] = useState(false)
    const [deleteModalOpen, setDeleteModalOpen] = useState(false)
    const [selectFacility, setSelectFacility] = useState(null)

    const [aptdata, setAptdata] = useState([])

    useEffect(() => {
        if (contactsData) {
            setTableData(contactsData.results)
            setCount(contactsData.count)
        }

    }, [contactsData])

    console.log(count, "count");


    const handleFilterChange = (field, value) => {
        setFilters((prev) => ({
            ...prev,
            [field]: value,
        }));
        setCurrentPage(1);
    };



    const tableHeaders = [
        { label: "Name", key: "full_name" },
        { label: "Phone", key: "phone_number" },
        {
            label: "Date",
            key: "created_at",
            formatter: (value) => new Date(value).toISOString().split("T")[0],
        },
    ];


    const actionButtons = [
        {
            icon: "MdOutlineRemoveRedEye",
            onClick: (row) => {
                console.log(row, "row");
                setIsmodelOpen(true)
                setMedicalId(row.id)

            },
        },
     
        {
            icon: "RiDeleteBinLine",
            onClick: (row) =>{
                setSelectFacility(row)
                setDeleteModalOpen(true)

            },
        },
    ];
     const handleConfirmDelete = async () => {
        if (!selectFacility) return;
        setIsDeleting(true);
        try {
            await deleteMed(selectFacility.id).unwrap();
            setDeleteModalOpen(false);
            setSelectFacility(null);
        
        } catch (error) {
            console.error("Delete failed:", error);
            alert("Failed to delete Facility.");
        } finally {
            setIsDeleting(false);
        }
    };



    const filterFields = [
        { name: "name", label: "User Name", type: "text", width: "w-64" },
        { name: "email", label: "Email", type: "text", width: "w-64" },
        { name: "role", label: "Role", type: "text", width: "w-64" },

    ];

    return (
        <>
            <ListLayout
                title="Staff List"
                filterFields={filterFields}
                onFilterChange={handleFilterChange}
                tableHeaders={tableHeaders}
                tableData={tableData}
                actionButtons={actionButtons}
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                pageSize={pageSize}
                setPageSize={setPageSize}
                totalCount={count}
            />
            <DetailModal
                medicalinfoId={medicalId}
                isopen={isModalOpen}
                onclose={() => { setIsmodelOpen(false) }}
            />
              <ConfirmDeleteModal
                            isOpen={deleteModalOpen}
                            onClose={() => setDeleteModalOpen(false)}
                            onConfirm={handleConfirmDelete}
                            itemName={selectFacility?.name}
            
                            isDeleting={isDeleting}
                        />

        </>
    );
}

export default Contacted
